import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-xsmall);

  & > svg {
    width: 20px;

    & path {
      stroke: var(--brand-900);
    }
  }

  & p {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-regular);
    color: var(--brand-900);
  }

  & button {
    display: flex;
    align-items: center;

    & path {
      stroke: var(--grey-500);
    }
  }
`;
